'use client';

import { MicrocopyFragment } from '@graphql/generated-contentful/graphql';
import { useFlags } from '@lib/flags/amplitude/client';
import { FLAG_TREATMENT, Flags } from '@lib/flags/flagConstants';
import { Tag } from '@lib/types/common/Tag';
import { SearchResultsBanner as SearchResultsBannerType } from '@lib/types/search/SearchResultsBanner';
import { SearchPageContent } from './SearchPageContent';
import { SearchPageContentV2 } from './SearchPageContent.v2';

export type SearchPageContentWrapperProps = {
  isListingPage: boolean;
  mappedSearchResultsBanners: SearchResultsBannerType[];
  mappedProductTags: Tag[] | undefined;
  paginationMicrocopy: MicrocopyFragment[];
};

/**
 * Client-side wrapper that switches between V1 and V2 layouts
 * based on UI_AND_MISSING_FILTERS feature flag
 */
export const SearchPageContentWrapper = ({
  isListingPage,
  mappedSearchResultsBanners,
  mappedProductTags,
  paginationMicrocopy,
}: SearchPageContentWrapperProps) => {
  const { flags, loading } = useFlags();

  const isProductCardV2Enabled =
    flags[Flags.UI_AND_MISSING_FILTERS]?.value === FLAG_TREATMENT;

  // While loading flags, render V1 to avoid flash
  // Once flags are loaded, render appropriate version
  if (loading || !isProductCardV2Enabled) {
    return (
      <SearchPageContent
        isListingPage={isListingPage}
        mappedSearchResultsBanners={mappedSearchResultsBanners}
        mappedProductTags={mappedProductTags}
        paginationMicrocopy={paginationMicrocopy}
      />
    );
  }

  return (
    <SearchPageContentV2
      mappedSearchResultsBanners={mappedSearchResultsBanners}
      mappedProductTags={mappedProductTags}
      paginationMicrocopy={paginationMicrocopy}
    />
  );
};
